const DirectFooterIcon = ({ ...props }: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="90"
      height="30"
      viewBox="0 0 90 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21648_54276)">
        <path d="M28.3977 6.2373H24.793V21.0811H28.3977V6.2373Z" fill="white" />
        <path
          d="M87.9953 17.3385C86.8672 17.2824 85.9473 18.1672 85.9473 19.282C85.9473 20.3968 86.8121 21.2283 87.8936 21.2283C88.9751 21.2283 89.8932 20.3084 89.8381 19.1812C89.7896 18.1947 88.9808 17.3869 87.9953 17.3385Z"
          fill="#FFC320"
        />
        <path
          d="M68.297 9.29827C69.5268 9.29827 70.6302 9.82858 71.2023 10.4644L73.3444 8.11031C72.1565 6.75318 70.3546 6.05371 68.0851 6.05371C63.8018 6.05371 60.5781 9.31918 60.5781 13.7298C60.5781 18.1405 63.8018 21.406 68.0851 21.406C70.3536 21.406 72.1565 20.7065 73.3444 19.3494L71.2023 16.9953C70.6302 17.6311 69.5268 18.1614 68.297 18.1614C65.9011 18.1614 64.0774 16.3168 64.0774 13.7298C64.0774 11.1429 65.9011 9.29827 68.297 9.29827Z"
          fill="white"
        />
        <path
          d="M74.4824 9.38304H78.5956V21.1524H82.2004V9.38304H86.3145V6.30859H74.4824V9.38304Z"
          fill="white"
        />
        <path
          d="M37.3011 12.811H34.5022V9.31175H37.3011C38.5527 9.31175 39.2731 10.0112 39.2731 11.0509C39.2731 12.0906 38.5518 12.811 37.3011 12.811ZM42.8788 11.0509C42.8788 8.08197 40.9914 6.2373 37.7687 6.2373H30.8984V21.0811H34.5032V15.8855H36.6235L39.3805 21.0811H43.1972V20.911L40.1227 15.4825C41.9037 14.783 42.8797 13.214 42.8797 11.0509"
          fill="white"
        />
        <path
          d="M45.3906 21.0802H61.7807L59.4903 18.0057H48.9954V14.995H58.1835V12.0469H48.9954V9.31175H59.4903L61.7807 6.2373H45.3906V21.0802Z"
          fill="white"
        />
        <path
          d="M8.96421 17.425H10.1189C13.0926 17.425 13.3245 14.8295 13.3245 14.0341C13.3245 12.6998 12.9082 10.4626 10.1189 10.4626H8.96421V17.4259V17.425ZM10.1189 26.1903H0.0544928V7.55066H10.1189C12.7372 7.55066 14.1922 8.77378 14.9525 9.79923C15.7793 10.915 16.2345 12.4185 16.2345 14.0331C16.2345 17.0686 14.3205 20.335 10.1189 20.335H6.05323V10.4616H2.96547V23.2802H10.1189C13.2912 23.2802 15.69 22.3907 17.2476 20.6353C18.6314 19.0767 19.3632 16.794 19.3632 14.0341C19.3632 8.59036 15.5617 4.78794 10.1189 4.78794H-0.0234375V1.87695H10.1189C17.1621 1.87695 22.2741 6.98899 22.2741 14.0341C22.2741 21.6465 17.7304 26.1912 10.1189 26.1912"
          fill="white"
        />
        <path
          d="M27.0804 25.3085C27.0804 26.0565 26.6547 26.5202 25.9533 26.5202C25.2519 26.5202 24.8262 26.047 24.8262 25.3085V24.1719H25.9533C26.6727 24.1719 27.0804 24.5786 27.0804 25.3085ZM26.6442 25.3085C26.6442 24.8352 26.4171 24.5511 25.9628 24.5511H25.2814V25.3085C25.2814 25.8198 25.537 26.1515 25.9628 26.1515C26.3886 26.1515 26.6442 25.8293 26.6442 25.3085Z"
          fill="#61DFFF"
        />
        <path
          d="M29.3239 26.4724H28.8982V25.2987C28.8982 24.7684 28.6235 24.5033 28.1978 24.5033C27.772 24.5033 27.7245 24.5888 27.5163 24.6924L27.3652 24.3797C27.6779 24.2001 27.9716 24.1431 28.2643 24.1431C28.8706 24.1431 29.3249 24.4938 29.3249 25.2883V26.4715L29.3239 26.4724Z"
          fill="#61DFFF"
        />
        <path d="M30.3471 24.1719H29.9023V26.4727H30.3471V24.1719Z" fill="#61DFFF" />
        <path
          d="M33.1878 25.2512C33.1878 26.0372 32.781 26.5105 32.0331 26.5105C31.2851 26.5105 30.8594 26.0372 30.8594 25.2512V24.1716H31.3041V25.2512C31.3041 25.81 31.5693 26.1322 32.0236 26.1322C32.4779 26.1322 32.7335 25.81 32.7335 25.2512C32.7335 24.6924 32.5729 24.5318 32.2412 24.5318C31.9095 24.5318 31.9761 24.5603 31.8535 24.6268L31.7394 24.2952C31.8905 24.2096 32.0616 24.144 32.2982 24.144C32.8095 24.144 33.1697 24.5042 33.1697 25.2522H33.1887L33.1878 25.2512Z"
          fill="#61DFFF"
        />
        <path d="M34.1147 24.1719H33.6699V26.4727H34.1147V24.1719Z" fill="#61DFFF" />
        <path
          d="M37.1346 25.3178C37.1346 26.2834 36.5567 26.7196 35.6672 26.3879L35.7717 26.0287C36.3876 26.2843 36.7183 25.9906 36.7183 25.3187C36.7183 24.6468 36.4627 24.5328 36.112 24.5328C35.7613 24.5328 35.5342 24.8835 35.3925 25.4043L35.1084 26.4744H34.6636L34.9573 25.4043L34.541 24.1735H34.9858L35.2034 24.8645C35.364 24.4387 35.6767 24.145 36.1025 24.145C36.7278 24.145 37.1441 24.6278 37.1441 25.3187H37.1346V25.3178Z"
          fill="#61DFFF"
        />
        <path
          d="M40.8944 24.1719V25.4976C40.8944 26.2646 40.5342 26.5012 40.0609 26.5012C39.5876 26.5012 39.7483 26.4822 39.5971 26.4347L39.6542 26.065C39.7682 26.0935 39.8908 26.122 40.0134 26.122C40.3261 26.122 40.4772 25.9709 40.4772 25.4596V24.5606H38.7637V24.1823H40.903H40.8935V24.1728L40.8944 24.1719ZM39.2094 27.1171H38.7836V25.1954L39.2094 25.1384V27.1171Z"
          fill="#61DFFF"
        />
        <path
          d="M43.3178 24.1714V24.2095L42.4558 26.4628H41.9825V26.4438L42.7304 24.5506H41.3477V23.7837H41.7934V24.1714H43.3273H43.3178Z"
          fill="#61DFFF"
        />
        <path
          d="M45.7311 24.1719V24.5501C45.3804 24.5501 45.2198 24.7487 45.2198 25.166V26.4727H44.775V25.1755C44.775 24.8628 44.8796 24.6642 45.0497 24.5501H43.5918V24.1719H45.7415H45.732H45.7311Z"
          fill="#61DFFF"
        />
        <path
          d="M49.6717 25.28V26.4632H49.2269V25.28C49.2269 24.7782 49.0283 24.5416 48.5455 24.5416H48.0627V25.9148C48.0627 26.3026 47.8451 26.4832 47.5419 26.4832C47.2387 26.4832 47.1912 26.4547 47.0781 26.4071L47.1447 26.0564C47.2207 26.0755 47.2958 26.0945 47.4003 26.0945C47.5609 26.0945 47.6179 25.9994 47.6179 25.7818V24.5321H47.3053V24.1538H48.5455C49.3315 24.1538 49.6536 24.476 49.6536 25.2619H49.6726V25.2809L49.6717 25.28Z"
          fill="#61DFFF"
        />
        <path d="M50.5991 24.1719V25.4691L50.1543 25.5452V24.1719H50.5991Z" fill="#61DFFF" />
        <path
          d="M53.2962 26.0944V26.4726H51.0619V26.0944H52.5293V25.2799C52.5293 24.8162 52.3307 24.513 51.8764 24.513C51.4221 24.513 51.3746 24.608 51.157 24.7211L51.0059 24.3989C51.309 24.2193 51.6217 24.1338 51.9524 24.1338C52.6719 24.1338 52.9845 24.5405 52.9845 25.2419V26.0944H53.2972H53.2962Z"
          fill="#61DFFF"
        />
        <path
          d="M56.0252 25.3178C56.0252 26.2834 55.4474 26.7196 54.5578 26.3879L54.6624 26.0287C55.2782 26.2843 55.6089 25.9906 55.6089 25.3187C55.6089 24.6468 55.3533 24.5328 55.0026 24.5328C54.6519 24.5328 54.4248 24.8835 54.2832 25.4043L53.999 26.4744H53.5542L53.8479 25.4043L53.4316 24.1735H53.8764L54.094 24.8645C54.2547 24.4387 54.5673 24.145 54.9931 24.145C55.6184 24.145 56.0347 24.6278 56.0347 25.3187H56.0252V25.3178Z"
          fill="#61DFFF"
        />
        <path
          d="M59.9998 25.28V26.4632H59.555V25.28C59.555 24.7782 59.3564 24.5416 58.8736 24.5416H58.3908V25.9148C58.3908 26.3026 58.1732 26.4832 57.87 26.4832C57.5669 26.4832 57.5193 26.4547 57.4062 26.4071L57.4728 26.0564C57.5488 26.0755 57.6239 26.0945 57.7284 26.0945C57.889 26.0945 57.9461 25.9994 57.9461 25.7818V24.5321H57.6334V24.1538H58.8736C59.6596 24.1538 59.9818 24.476 59.9818 25.2619H60.0008V25.2809L59.9998 25.28Z"
          fill="#61DFFF"
        />
        <path d="M61.0229 24.1719H60.5781V26.4727H61.0229V24.1719Z" fill="#61DFFF" />
        <path d="M62.0366 24.1719V25.4691L61.5918 25.5452V24.1719H62.0366Z" fill="#61DFFF" />
        <path
          d="M64.6217 24.1719V24.5501C64.271 24.5501 64.1104 24.7487 64.1104 25.166V26.4727H63.6656V25.1755C63.6656 24.8628 63.7702 24.6642 63.9403 24.5501H62.4824V24.1719H64.6322H64.6227H64.6217Z"
          fill="#61DFFF"
        />
        <path
          d="M67.0534 24.1718V24.9388C67.0534 25.9519 66.6466 26.5677 64.9797 26.6333L64.9512 26.2636C65.1688 26.2446 65.3579 26.2256 65.5385 26.1875L65.0082 24.1519H65.472L65.9738 26.083C66.4661 25.9034 66.6362 25.5812 66.6362 24.9283V24.1614H67.0809H67.0524V24.1709L67.0534 24.1718Z"
          fill="#61DFFF"
        />
        <path
          d="M69.4496 24.1714V24.2095L68.5877 26.4628H68.1144V26.4438L68.8623 24.5506H67.4805V23.7837H67.9252V24.1714H69.4591H69.4496Z"
          fill="#61DFFF"
        />
        <path
          d="M71.9974 26.0944V26.4726H69.7631V26.0944H71.2305V25.2799C71.2305 24.8162 71.0318 24.513 70.5776 24.513C70.1233 24.513 70.0758 24.608 69.8581 24.7211L69.707 24.3989C70.0102 24.2193 70.3229 24.1338 70.6536 24.1338C71.373 24.1338 71.6857 24.5405 71.6857 25.2419V26.0944H71.9984H71.9974Z"
          fill="#61DFFF"
        />
        <path
          d="M75.8709 25.28V26.4632H75.4261V25.28C75.4261 24.7782 75.2275 24.5416 74.7447 24.5416H74.2619V25.9148C74.2619 26.3026 74.0443 26.4832 73.7411 26.4832C73.438 26.4832 73.3904 26.4547 73.2773 26.4071L73.3439 26.0564C73.4199 26.0755 73.495 26.0945 73.5995 26.0945C73.7601 26.0945 73.8172 25.9994 73.8172 25.7818V24.5321H73.5045V24.1538H74.7447C75.5307 24.1538 75.8528 24.476 75.8528 25.2619H75.8719V25.2809L75.8709 25.28Z"
          fill="#61DFFF"
        />
        <path d="M76.8823 24.1719H76.4375V26.4727H76.8823V24.1719Z" fill="#61DFFF" />
        <path d="M77.9047 24.1719V25.4691L77.459 25.5452V24.1719H77.9047Z" fill="#61DFFF" />
        <path d="M78.9174 24.1719H78.4727V26.4727H78.9174V24.1719Z" fill="#61DFFF" />
        <path
          d="M79.4018 26.0945H79.9891V24.9673C79.9891 24.6832 79.9131 24.5511 79.6765 24.5511H79.4778V24.1719H79.8095C80.2543 24.1719 80.4244 24.399 80.4244 24.8533V26.4822H79.3828V26.104H79.4018V26.0945Z"
          fill="#61DFFF"
        />
        <path
          d="M83.3787 25.3178C83.3787 26.2834 82.8009 26.7196 81.9113 26.3879L82.0159 26.0287C82.6317 26.2843 82.9625 25.9906 82.9625 25.3187C82.9625 24.6468 82.7068 24.5328 82.3561 24.5328C82.0054 24.5328 81.7783 24.8835 81.6367 25.4043L81.3525 26.4744H80.9078L81.2014 25.4043L80.7852 24.1735H81.2299L81.4476 24.8645C81.6082 24.4387 81.9208 24.145 82.3466 24.145C82.972 24.145 83.3882 24.6278 83.3882 25.3187H83.3787V25.3178Z"
          fill="#61DFFF"
        />
        <path
          d="M85.7936 24.1719V24.5501C85.4429 24.5501 85.2823 24.7487 85.2823 25.166V26.4727H84.8375V25.1755C84.8375 24.8628 84.9421 24.6642 85.1122 24.5501H83.6543V24.1719H85.804H85.7945H85.7936Z"
          fill="#61DFFF"
        />
        <path
          d="M87.1091 26.4727H86.6358C86.2575 25.3931 86.2851 24.7402 86.7964 24.5511H86.1055V24.1729H87.4692V24.5511C86.7688 24.5511 86.5883 25.0339 87.1091 26.4727Z"
          fill="#61DFFF"
        />
        <path
          d="M88.823 24.1718C89.609 24.1718 89.9682 24.5415 89.9682 25.3456V26.4727H89.5234V25.3456C89.5234 24.7867 89.3153 24.5501 88.8325 24.5501H87.8574V24.1709H88.8325H88.823V24.1718ZM88.3212 25.2039V26.4822H87.8764V25.2705L88.3212 25.2039Z"
          fill="#61DFFF"
        />
        <path d="M28.3977 6.2373H24.793V21.0811H28.3977V6.2373Z" fill="white" />
        <path
          d="M87.9953 17.3385C86.8672 17.2824 85.9473 18.1672 85.9473 19.282C85.9473 20.3968 86.8121 21.2283 87.8936 21.2283C88.9751 21.2283 89.8932 20.3084 89.8381 19.1812C89.7896 18.1947 88.9808 17.3869 87.9953 17.3385Z"
          fill="#FFC320"
        />
        <path
          d="M68.297 9.29827C69.5268 9.29827 70.6302 9.82858 71.2023 10.4644L73.3444 8.11031C72.1565 6.75318 70.3546 6.05371 68.0851 6.05371C63.8018 6.05371 60.5781 9.31918 60.5781 13.7298C60.5781 18.1405 63.8018 21.406 68.0851 21.406C70.3536 21.406 72.1565 20.7065 73.3444 19.3494L71.2023 16.9953C70.6302 17.6311 69.5268 18.1614 68.297 18.1614C65.9011 18.1614 64.0774 16.3168 64.0774 13.7298C64.0774 11.1429 65.9011 9.29827 68.297 9.29827Z"
          fill="white"
        />
        <path
          d="M74.4824 9.38304H78.5956V21.1524H82.2004V9.38304H86.3145V6.30859H74.4824V9.38304Z"
          fill="white"
        />
        <path
          d="M37.3011 12.811H34.5022V9.31175H37.3011C38.5527 9.31175 39.2731 10.0112 39.2731 11.0509C39.2731 12.0906 38.5518 12.811 37.3011 12.811ZM42.8788 11.0509C42.8788 8.08197 40.9914 6.2373 37.7687 6.2373H30.8984V21.0811H34.5032V15.8855H36.6235L39.3805 21.0811H43.1972V20.911L40.1227 15.4825C41.9037 14.783 42.8797 13.214 42.8797 11.0509"
          fill="white"
        />
        <path
          d="M45.3906 21.0802H61.7807L59.4903 18.0057H48.9954V14.995H58.1835V12.0469H48.9954V9.31175H59.4903L61.7807 6.2373H45.3906V21.0802Z"
          fill="white"
        />
        <path
          d="M8.96421 17.425H10.1189C13.0926 17.425 13.3245 14.8295 13.3245 14.0341C13.3245 12.6998 12.9082 10.4626 10.1189 10.4626H8.96421V17.4259V17.425ZM10.1189 26.1903H0.0544928V7.55066H10.1189C12.7372 7.55066 14.1922 8.77378 14.9525 9.79923C15.7793 10.915 16.2345 12.4185 16.2345 14.0331C16.2345 17.0686 14.3205 20.335 10.1189 20.335H6.05323V10.4616H2.96547V23.2802H10.1189C13.2912 23.2802 15.69 22.3907 17.2476 20.6353C18.6314 19.0767 19.3632 16.794 19.3632 14.0341C19.3632 8.59036 15.5617 4.78794 10.1189 4.78794H-0.0234375V1.87695H10.1189C17.1621 1.87695 22.2741 6.98899 22.2741 14.0341C22.2741 21.6465 17.7304 26.1912 10.1189 26.1912"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_21648_54276">
          <rect width="90" height="25.2798" fill="white" transform="translate(0 1.87598)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default DirectFooterIcon
